import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, PlusIcon } from 'lucide-react';
interface EmptyStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: React.ReactNode;
  variant?: 'default' | 'assessments';
}
const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No items found',
  description = 'Get started by creating your first item',
  actionLabel = 'Get Started',
  onAction,
  icon,
  variant = 'default'
}) => {
  const defaultIcon = variant === 'assessments' ? <FileTextIcon size={48} className="text-text-tertiary" data-id="element-1427" /> : icon;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="flex flex-col items-center justify-center py-16 px-4" data-id="element-1428">
      <motion.div initial={{
      scale: 0.8
    }} animate={{
      scale: 1
    }} transition={{
      delay: 0.1,
      type: 'spring',
      stiffness: 200
    }} className="w-24 h-24 rounded-full bg-surface flex items-center justify-center mb-6 shadow-custom-sm" data-id="element-1429">
        {defaultIcon}
      </motion.div>
      <h3 className="text-xl font-bold text-text-primary mb-2" data-id="element-1430">{title}</h3>
      <p className="text-text-secondary text-center max-w-md mb-6" data-id="element-1431">
        {description}
      </p>
      {onAction && <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={onAction} className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#00B75F] to-[#00a055] text-white font-semibold rounded-xl shadow-green-glow hover:shadow-lg transition-all" data-id="element-1432">
          <PlusIcon size={20} data-id="element-1433" />
          {actionLabel}
        </motion.button>}
    </motion.div>;
};
export default EmptyState;